export const tagIds = {
  LEAD_ONLY: 5310,
  VIP_ONLY: 5976,
  MYSTERY_BOX: 176855,
};

export const MEMBERSHIP_STATES = {
  VISITOR: 'visitor',
  LEAD: 'lead',
  VIP: 'vip',
  ELITE: 'elite',
};

export const productDetailPath = 'products';
